<template>
  <div class="d-flex flex-column">
    <PhaseSection
      data-testid="problem-solving-measure"
      data-tourid="problem-solving-measure-phase"
      :title="$t('problem_solving.phases.measure')"
      :description="$t('problem_solving.measure.measure_description')"
      :isEditMode="isEditMode"
      :hasNextButton="hasNextButton"
      :hasBackButton="hasBackButton"
      @next="$emit('next')"
      @back="$emit('back')"
    >
      <MediaContainer
        data-private
        slot="left"
        class="mt-6"
        :images="measureMedia"
        :readOnly="!isEditMode || isSaving"
        @change="handleMeasureMediaChange"
      />
      <TranslationLoading slot="right" v-if="isTranslating" />
      <div slot="right" v-else>
        <Attachments :rev="rev" :isEditMode="isEditMode" />
        <TextQuestion
          data-private
          tid="problemSolving-textarea-measure-description"
          v-model="measureDescription"
          :maxLength="$constants.problemSolving.measureDescriptionMaxLength"
          :question="$t('problem_solving.measure.description_label')"
          :placeholder="$t('problem_solving.measure.description_placeholder')"
          :isEditMode="isEditMode"
          rows="1"
          @focusOut="trackEvent('measureDescription')"
        />
      </div>
    </PhaseSection>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import trackerMixin from '@/mixins/tracking/trackerMixin.vue'
import TextQuestion from '@/components/Rev/TextQuestion.vue'
import PhaseSection from '@/components/Rev/PhaseSection/PhaseSection.vue'
import MediaContainer from '@/components/MediaContainer/MediaContainer.vue'
import Attachments from './Measure/Attachments'
import TranslationLoading from '@/components/Rev/TranslationLoading.vue'

export default {
  name: 'Measure',

  mixins: [trackerMixin],

  components: {
    MediaContainer,
    TextQuestion,
    PhaseSection,
    Attachments,
    TranslationLoading,
  },

  props: {
    isEditMode: {
      type: Boolean,
      default: false,
    },
    rev: {
      type: Object,
      required: true,
    },
    isSaving: Boolean,
    isTranslating: Boolean,
    hasNextButton: Boolean,
    hasBackButton: Boolean,
  },

  computed: {
    measureMedia() {
      return this.rev?.problemAnalysis?.measureMedia ?? []
    },

    measureDescription: {
      get() {
        return this.rev?.problemAnalysis?.measureDescription ?? ''
      },
      set(measureDescription) {
        this.$emit('revChange')
        this.updateMeasureDescription(measureDescription)
        this.trackEvent('measureDescription')
      },
    },
  },

  methods: {
    ...mapMutations({
      updateMeasureDescription: 'problemSolving/updateMeasureDescription',
      updateMeasureMedia: 'problemSolving/updateMeasureMedia',
    }),

    handleMeasureMediaChange(media) {
      this.trackEvent('measureMedia')
      this.$emit('revChange')
      this.updateMeasureMedia(media)
    },

    trackEvent(changedField) {
      this.trackUpdate(this.rev, changedField)
    },
  },
}
</script>
